/**
 * Holster free-shipping progress bar (cart drawer, preview redesign).
 * Single tier 49,90 EUR. Updates live on cart changes via /cart.js.
 */
(function (window, document) {
  'use strict';
  var DEFAULT_THRESHOLD = 4990;
  var SHIPPING_CENTS = 690;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function eur(cents) {
    var n = Math.max(0, Number(cents) || 0) / 100;
    return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0€';
  }
  function subtotalOf(cart) {
    if (!cart) return 0;
    if (cart.items_subtotal_price != null) return Number(cart.items_subtotal_price);
    return Number(cart.total_price) || 0;
  }

  function tobaccoOnly(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) return false;
    for (var i = 0; i < items.length; i++) {
      var t = String(items[i].product_type || '').toLowerCase();
      if (t.indexOf('tabak') === -1 && t.indexOf('tobacco') === -1) return false;
    }
    return true;
  }

  function applyBar(el, subtotal, tob) {
    var threshold = Number(el.getAttribute('data-threshold')) || DEFAULT_THRESHOLD;
    var remaining = Math.max(0, threshold - subtotal);
    var pct = threshold > 0 ? Math.min(100, Math.max(0, (subtotal / threshold) * 100)) : 0;
    var unlocked = remaining === 0 && !tob;
    el.classList.toggle('holster-fsbar--tobacco-only', !!tob);
    el.style.setProperty('--holster-fsbar-progress', String(pct));
    el.setAttribute('data-subtotal', String(subtotal));
    el.setAttribute('data-unlocked', unlocked ? 'true' : 'false');
    el.classList.toggle('holster-fsbar--unlocked', unlocked);
    var label = el.querySelector('[data-holster-fsbar-label]');
    if (label) {
      label.innerHTML = tob
        ? 'Reine Tabakbestellungen: Versand immer 6,90\u00a0€. Gratis Versand ab 49,90\u00a0€, wenn weitere Produkte im Warenkorb sind.'
        : unlocked
        ? '✔ Sie haben gratis Versand!'
        : 'Nur noch <strong>' + eur(remaining) + '</strong> bis <strong>gratis Versand</strong>';
    }
    var pill = el.querySelector('[data-holster-fsbar-pill]');
    if (pill) pill.textContent = eur(subtotal);
    var tag = el.querySelector('[data-holster-fsbar-tag]');
    if (tag) tag.textContent = (unlocked ? '✔ ' : '') + eur(threshold);
  }

  function applyShipping(subtotal, tob) {
    var free = subtotal >= DEFAULT_THRESHOLD && !tob;
    document.querySelectorAll('[data-holster-shipping-value]').forEach(function (n) {
      n.textContent = free ? 'kostenlos' : eur(SHIPPING_CENTS);
      n.classList.toggle('is-free', free);
    });
  }

  function applyFromCart(cart) {
    var subtotal = subtotalOf(cart);
    var tob = tobaccoOnly(cart);
    document.querySelectorAll('[data-holster-fsbar]').forEach(function (el) {
      applyBar(el, subtotal, tob);
    });
    applyShipping(subtotal, tob);
  }

  var timer = null;
  function refresh() {
    if (timer) return;
    timer = window.setTimeout(function () {
      timer = null;
      fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(applyFromCart)
        .catch(function () {});
    }, 120);
  }

  function boot() {
    refresh();
    ['cart:update', 'cart:refresh', 'cart:change', 'theme:cart:change', 'cart-drawer:refreshed',
      'shopify:cart:lines-update', 'holster:cart:rerendered'].forEach(function (ev) {
      document.addEventListener(ev, refresh);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.HolsterFreeShippingBar = { refresh: refresh, applyFromCart: applyFromCart };
})(window, document);
